import { Button } from "@nextui-org/react"
import { Text } from "@nextui-org/react"

import './index.css'

export default ({text, onClick}) => {
    return (
        <>
            <Button 
                className="gl-btn"
                bordered 
                color="primary" 
                auto 
                onClick={onClick}
                css={{backgroundColor: "#ffffff", zIndex: 1}}
                >
                <Text b color="inherit" size="$sm">{text}</Text>
            </Button>
        </>
    )
}